import { apiUserFetch } from '..';
import { UploadRequestResponse } from '../files/types';
import { ContactCodeUserRes, GenerateContactCodeRes, QrTokenRes } from './types';

export type UserUploadRequestPayload = {
  userId: string;
  filename: string;
  contentType: string;
  contentEncoding?: string;
  category: 'logo' | 'profile' | 'document';
};

export const _postUserUploadRequest = async ({
  userId,
  filename,
  contentType,
  contentEncoding,
  category,
}: UserUploadRequestPayload) => {
  if (!userId) {
    throw new Error('userId is required for user file uploads');
  }

  return apiUserFetch<UploadRequestResponse>(
    `/users/${encodeURIComponent(String(userId))}/upload-request`,
    {
      method: 'POST',
      body: {
        filename,
        contentType,
        contentEncoding,
        category,
      },
    },
  );
};

type BlockUserPayload = {
  userId: string;
  blockedBy: string;
  reason: string;
  internalReference: string;
};

export const _blockUser = ({ userId, blockedBy, reason, internalReference }: BlockUserPayload) => {
  return apiUserFetch(`/admin/users/${userId}/block`, {
    method: 'POST',
    body: { blockedBy, reason, internalReference },
  });
};

type UnblockUserPayload = { userId: string; unblockedBy: string };

export const _unblockUser = ({ userId, unblockedBy }: UnblockUserPayload) => {
  return apiUserFetch(`/admin/users/${userId}/unblock`, {
    method: 'POST',
    body: { unblockedBy },
  });
};

type UpdateUserTagsPayload = {
  userId: string;
  tagIds: string[];
};

export const _updateUserTags = ({ userId, tagIds }: UpdateUserTagsPayload) => {
  return apiUserFetch(`/admin/users/${userId}/tags`, {
    method: 'PUT',
    body: { tagIds },
  });
};

export const _postContactCode = () => {
  return apiUserFetch<GenerateContactCodeRes>('/contact-code', {
    method: 'POST',
  });
};
export const _getContactCodeUser = (code: string) => {
  return apiUserFetch<ContactCodeUserRes>(`/contact-code/${code}/user`, {
    method: 'GET',
  });
};

export const _getQrTokenUser = (token: string) => {
  return apiUserFetch<ContactCodeUserRes>(`/qr/${encodeURIComponent(token)}/user`, {
    method: 'GET',
  });
};

export const _postQrToken = () => {
  return apiUserFetch<QrTokenRes>('/qr/token', {
    method: 'POST',
  });
};

export const _generateKycAdminReport = (userId: string): Promise<Blob> =>
  apiUserFetch<Blob, 'blob'>(`/kyc/${userId}/admin-report`);
